<template>
    <v-dialog v-model="shows" persistent v-bind="{ width }">
        <template #activator="{ attrs, on }">
            <template v-if="$scopedSlots['activator']">
                <slot name="activator" v-bind="{ attrs, on }" />
            </template>
            <template v-else>
                <v-btn x-small block tile color="transparent" width="100%" height="100%" v-bind="{ ...attrs, title: title_activator }" v-on="on">
                    <span v-if="value?.data"> {{ value.data }} </span>
                    <span v-else style="opacity: 0.5; word-break: auto-phrase;"> {{ value.term }} </span>
                </v-btn>
            </template>
        </template>
        <v-card>
            <v-card-title> "{{ value.term }}" 입력 </v-card-title>
            <v-card-text>
                <slot v-bind="{ save }" />
            </v-card-text>
            <v-card-actions>
                <v-btn x-small text tile color="error" @click="exit">취소하기</v-btn>
                <v-spacer />
                <v-btn x-small text tile color="primary" @click="save">저장하기</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { initEmploymentField } from "@/assets/variables";

export default {
    props: {
        value: { type: Object, default: initEmploymentField },
        width: { type: [Number, String], default: 480 },
    },
    data: () => ({
        shows: false,
    }),
    computed: {
        title_activator() {
            if (this.value.data) return "수정하기";
            else return "작성하기";
        },
        text_activator() {
            return this.value.data || this.value.term;
        },
    },
    methods: {
        exit() {
            this.$emit("sync");
            this.shows = false;
        },
        save() {
            this.$emit("emit");
            this.shows = false;
        },
    },
};
</script>

<style></style>
